import { render, staticRenderFns } from "./JobComments.vue?vue&type=template&id=dcea23a4&scoped=true"
import script from "./JobComments.vue?vue&type=script&lang=js"
export * from "./JobComments.vue?vue&type=script&lang=js"
import style0 from "./JobComments.vue?vue&type=style&index=0&id=dcea23a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcea23a4",
  null
  
)

export default component.exports